import { ReactComponent as EditIcon } from 'assets/icons/Edit.svg';
import { IconButton, SvgIcon } from "@mui/material";

export const useEditCell = (props) => {
    const { action, feature, role } = props

    return {
        accessorKey: 'edit',
        header: "עריכה",
        enableSorting: false,
        feature: feature,
        role: role,
        cell: ({ row }) => {
            const data = row.original

            return (
                <IconButton
                    label="Edit"
                    className="textPrimary"
                    onClick={() => action(data)}
                >
                    <SvgIcon className={data.invalid && "invalid-icon"} component={EditIcon} inheritViewBox />
                </IconButton>
            );
        }
    }
}


export default useEditCell